const comments = [
  {
    name: '追剧达人小王',
    rating: 5,
    text: '用了大半年了，片源更新速度真的快，热门电视剧当晚就有高清资源。画质清晰，加载流畅，比很多收费app还好用，强烈推荐给爱追剧的朋友。',
    date: '2026年7月28日',
  },
  {
    name: '电影爱好者老李',
    rating: 5,
    text: '电影库太全了，很多冷门老片都能搜到。离线下载功能出差必备，飞机上也能看。最关键是完全免费，没有乱七八糟的广告和套路。',
    date: '2026年7月25日',
  },
  {
    name: '宝妈小陈',
    rating: 5,
    text: '给孩子下载了很多动画片，分类很清晰，找片方便。支持电视盒子投屏，周末一家人窝在沙发上看电影，幸福感满满。画质和流畅度都很满意。',
    date: '2026年7月22日',
  },
  {
    name: '数码控阿杰',
    rating: 5,
    text: '安卓和苹果都能用，界面简洁无广告，启动速度很快。4K资源越来越多了，在大屏电视上看效果惊艳。更新频率很高，团队很用心在维护。',
    date: '2026年7月20日',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">用户评价</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">来自真实用户的观影反馈，听听他们怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: comment.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{comment.text}</p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                <span className="text-xs text-foreground-400">{comment.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}